import React from 'react';
import { Box } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../utils';
import ExternalBanner from '../Common/ExternalBanner/ExternalBanner';

import invertedMessages from './messages';

import './BeginClassification.css';

interface BeginClassificationProps {
  closeExtBanner: () => void;
}

function BeginClassification({
  closeExtBanner = () => {},
}: BeginClassificationProps) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <Box className='Ext-BeginClassification'>
      <ExternalBanner
        heading={l(
          'NEW: Classify your users for better security insights and management.'
        )}
        subHeading={l(
          'We’ll can help you define which types of users pose higher-risk to your business and tools to manage your security posture.'
        )}
        buttonText={l('Begin Identity Classification')}
        closeExtBanner={closeExtBanner}
        showButton
        showClose
        illustration='Classification'
      />
    </Box>
  );
}

export default BeginClassification;
